export default "__VITE_ASSET__WYOM55$h__"